import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=63f32570&scoped=true"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=63f32570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f32570",
  null
  
)

export default component.exports